import { IFromPrice, IPrice, ISFCCFamilyPrice, ISFCCGroupPrice, ISFCCPrice } from '@gn-audio/core/api/pricing/models';
import { Component, Inject, Input } from 'angular-ts-decorators';
import { ITime, millisecondsToTime, zeroPad } from 'src/Foundation/Design/platform';
import { IOfferCountdownService, IOfferExpiration } from './offer-countdown.service';

import template from './offer-countdown.component.html';

const checkDelay = 60000;

const enum ReplacementTimeValue {
  Days = '[days]',
  Hours = '[hours]',
  Minutes = '[minutes]',
}

function formatClockItem(val: number): string {
  return `<span class="offer-countdown__clock-item">${zeroPad(val)}</span>`;
}

@Component({
  selector: 'offerCountdown',
  template,
})
export class OfferCountdownComponent {
  public static $inject: ReadonlyArray<string> = ['offerCountdownService', '$timeout'];

  @Input('=') public isOfferActive = false;
  @Input('@') public message = '';
  @Input() public pId?: string;
  @Input('@') public pType?: string;

  private time: ITime = { days: 0, hours: 0, minutes: 0 };
  private price?: IFromPrice | IPrice | ISFCCFamilyPrice | ISFCCGroupPrice;

  constructor(
    @Inject('offerCountdownService') private offerCountdownService: IOfferCountdownService,
    @Inject('$timeout') private $timeout: ng.ITimeoutService
  ) { }

  public onPriceLoaded(price?: IFromPrice | IPrice | ISFCCPrice): void {
    this.price = price;
    if (this.price?.offerEndDate) {
      this.loadOfferTime();
    }
  }

  public get discount(): number {
    return Math.floor(this.price?.discountPercentage) || 0;
  }

  public get offerMessage(): string {
    return this.message
      .replace(ReplacementTimeValue.Days, formatClockItem(this.time.days))
      .replace(ReplacementTimeValue.Hours, formatClockItem(this.time.hours))
      .replace(ReplacementTimeValue.Minutes, formatClockItem(this.time.minutes));
  }

  private loadOfferTime(): void {
    this.offerCountdownService.getOfferExpiration(this.price.offerEndDate)
      .then((res: ng.IHttpResponse<IOfferExpiration>): void => {
        this.time = millisecondsToTime(res.data.milliseconds);
        this.isOfferActive = Boolean(!res.data.expired && this.discount);
        if (this.isOfferActive) {
          this.$timeout(this.loadOfferTime.bind(this), checkDelay, true);
        }
      });
  }
}
